/*
 *             Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
export const UNGROUPED_COMMANDS_GROUP_ID='_ungrouppedCommands';export function normalizeCommandsConfig(_0x503c6d,_0x1f6fc1){const _0x133918=(0x0,_0x1f6fc1['t'])('Other');return _0x503c6d['length']?'groupId'in _0x503c6d[0x0]?_0x503c6d:[{'groupId':'_ungrouppedCommands','groupLabel':_0x133918,'order':0x1/0x0,'commands':_0x503c6d}]:[{'groupId':'_ungrouppedCommands','groupLabel':_0x133918,'order':0x1/0x0,'commands':[]}];}